import { Components, Theme } from "@mui/material";
import { lightColors } from "../system/colors";

export const MuiAutocomplete = (): Components["MuiAutocomplete"] => ({
    styleOverrides: { noOptions: { display: "none" } },
    defaultProps: {
        componentsProps: { paper: { style: { display: "block" } } },
    },
});
